// @ utilities
import apiURLBuilder from '../core/apiURLBuilder';
import  { APIPost } from 'utilities/APIRequestHelper';
import moment from 'moment';  ;
const chunk = require('lodash/array/chunk');


// @ constants
import actionTypes from 'constants/actionTypes';
import {
  API_CHANNEL,
  PERIODICITY_DOCUMENT_SERVICE,
  CONNECTION_CHANNEL_INTERNET,
  BROKER_PRODUCT_TYPE_FUNDS_ES,
  BROKER_ORDER_TYPE_BUY,
} from 'constants/index';

import { es } from 'commonsConstants/dateFormatTypes';
const { DATE_FORMAT_WITH_DASHES_DATETIME } = es;

// @actions
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');

// @utils
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { toCamelCase } = require('utilities/stringHelper');

const fetchPeriodicalContributionsRequest = () => (
    {
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_REQUEST,
    }
);

const fetchPeriodicalContributionsSuccess = (response) => (
    {
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_SUCCESS,
        payload: response
    }
);

const fetchPeriodicalContributionsError = (error) => (
    {
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_ERROR,
        payload: error
    }
);

const handleRowClick = (rowId) => (dispatch, getState) => {
    let id = rowId;
    const immBrokerPeriodicalFundsContributions = getState().brokerPeriodicalFundsContributions;
    const expandRowId = immBrokerPeriodicalFundsContributions.get('expandRowId');
    if (expandRowId === rowId) {
        id = undefined;
    }
    dispatch({
        type: actionTypes.HANDLE_ROW_CLICK_PERIODICAL_CONTRIBUTION_TABLE,
        payload: id
    });
};

const validatePeriodicalContributions = (response, contractsInfo) => (dispatch) => {
    const periodicalContributionsList = contractsInfo.map(contract => {
        const recurringTransfers = response.recurringTransfers.find(recurringTransfer => recurringTransfer.contractCode === contract.contractCode);
        if(recurringTransfers) {
            return {
                ...contract,
                ...recurringTransfers,
                isNewContribution: false,
            }
        } else {
            return {
                ...contract,
                isNewContribution: true,
                nextInstallmentDate: null,
                periodicity: null,
                currencyCode: null,
                amount: null,
                subscriptionDate: null,
                subscriptionDateId: null,
            }
        }

    });

    const totalPages = Math.round(periodicalContributionsList.length/20);
    const data = chunk(periodicalContributionsList, 20);
     
    dispatch(fetchPeriodicalContributionsSuccess({recurringTransfers:data, totalPages: totalPages}))
}

const handlePeriodicalContributionSelected = (data) => {
    return {
        type: actionTypes.BROKER_PERIODICAL_CONTRIBUTION_SELECTED,
        payload: data
    }
}

const getPeriodicalContributions =
  (productCode = null, contractNumber = null) =>
  (dispatch, getState) => {
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const immContracts = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).toJS();
    const contractsInfo = [];
    const listContractToSearch = [];
    if (productCode && contractNumber) {
      listContractToSearch.push({
        contractCode: contractNumber,
        productId: productCode,
      });
    } else {
      immContracts.forEach(immElement => {
        if (immElement.contractNumber && immElement.producto) {
          contractsInfo.push({
            contractCode: immElement.contractNumber,
            productId: immElement.producto,
            marketable: immElement.marketable,
            marketName: immElement.name,
            nameHolder: immElement.nameHolder,
            foundAmount: immElement.totalOperations.totalValue,
            foundCurrency: immElement.totalOperations.totalValueCurrency,
            associatedAccount: immElement.associatedAccount,
            isin: immElement.isin,
            shares: immElement.participaciones,
            fullContract: immElement.fullContrato,
            secId: immElement.customInstitutionSecurityId,
            id: immElement.id,
          });
          listContractToSearch.push({
            contractCode: immElement.contractNumber,
            productId: immElement.producto,
          });
        }
      });
    }

    const url = apiURLBuilder.getURL('brokerGetRecurringTransfersList');
    const requestData = {
      query: {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contracts: listContractToSearch,
      },
      header: {
        version: 2,
      },
    };

    APIPost(dispatch, url, requestData).then(
      response => {
        if(productCode && contractNumber) {
            const contributionSelected =  response.recurringTransfers.find(recurringTransfer => recurringTransfer.contractCode === contractNumber);
            const foundSelected = immContracts.find(immElement => immElement.contractNumber === contractNumber);
            const data = {
                ...contributionSelected,
                contractCode: foundSelected.contractNumber,
                productId: foundSelected.producto,
                marketable: foundSelected.marketable,
                marketName: foundSelected.name,
                nameHolder: foundSelected.nameHolder,
                amount: foundSelected.totalOperations.totalValue,
                foundCurrency: foundSelected.totalOperations.totalValueCurrency,
                associatedAccount: foundSelected.associatedAccount,
                isin: foundSelected.isin,
                shares: foundSelected.participaciones,
                fullContract: foundSelected.fullContrato,
                secId: foundSelected.customInstitutionSecurityId,
                id: foundSelected.id,
                foundSelected: false,
            }

            dispatch(handlePeriodicalContributionSelected(data))
        }
        dispatch(validatePeriodicalContributions(response, contractsInfo))
    },
      error => dispatch(fetchPeriodicalContributionsError(error))
    );
  };

const fetchPeriodicalContributions= (productCode = null, contractNumber = null) => (dispatch, getState) => {
    const immBrokerMyInvestments = getState().brokerMyInvestments;
    if(!immBrokerMyInvestments.get('fetchSuccess')) {
        dispatch(BrokerMyInvestmentsActions.fetchMyInvestments())
    } else {
        dispatch(fetchPeriodicalContributionsRequest());
        dispatch(getPeriodicalContributions(productCode,contractNumber))
    }
}

const changePage = (page) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_PERIODICAL_CONTRIBUTION_CHANGE_PAGE,
        payload: page
    });
}

function contributionFundsDocumentStorageRequest(){
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_REQUEST
    }
}

function contributionFundsDocumentStorageSuccess() {
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_SUCCESS
    };
}

function contributionFundsDocumentStorageError() {
    return {
        type: actionTypes.INVESTMENT_FUND_DOCUMENT_STORAGE_ERROR
    };
}

const storeDocument = (orderResponse) => (dispatch, getState) => {
    const emittedDateTime = moment().format(DATE_FORMAT_WITH_DASHES_DATETIME);
    const immBrokerPeriodicalContribution = getState().brokerPeriodicalFundsContributions;
    const periodicalContributionSelected = immBrokerPeriodicalContribution.get('periodicalContributionSelected')
    const amount = periodicalContributionSelected.get('amount');
    const periodicity = toCamelCase(periodicalContributionSelected.get('periodicity'));
    const firstContributionDate = periodicalContributionSelected.get('subscriptionDate');
    const currencyCode = periodicalContributionSelected.get('currencyCode');
    const isin = periodicalContributionSelected.get('isin');
    const fundName = periodicalContributionSelected.get('marketName');
    const immProfile = getState().profile;
    const nameHolder = periodicalContributionSelected.get('nameHolder')

    const communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "productKID": "",
        "contract": "",
        "marketingReport": "",
        "economicReport": "",
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": isin,
        "isinDescribe": fundName,
        "idOrder" : '',
        "channel" : CONNECTION_CHANNEL_INTERNET,
        "orderType" : BROKER_ORDER_TYPE_BUY,
        "productType" : BROKER_PRODUCT_TYPE_FUNDS_ES,
        "holders" : nameHolder,
        "ccv" : "",
        "idContract": "",
        "ccc": "",
        "market": '',
        "sharesNumber": "",
        "orderCondition": getState().brokerProductFile.descripcionOrden,
        "sharesAmount":"" + amount,
        "termValidity": "",
        "conditionPrize": "",
        "currency": currencyCode,
        "mifidWarningText": "",
        "dateTime" : emittedDateTime,
        "periodicContribution": {
            "amount": amount,
            "contributionOrderType": "ORDEN BAJA DE COMPRA PERIÓDICA",
            "date":  firstContributionDate,
            "periodicity": PERIODICITY_DOCUMENT_SERVICE[periodicity],
        }
    };

    const data = {
        query: communicationServiceInput,
    };

    const dataRequest = { url: "communication", request: data };
    dispatch(contributionFundsDocumentStorageRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(dataRequest.url), dataRequest.request).then(
        () => {
            dispatch(contributionFundsDocumentStorageSuccess());
        },
        () => {
            dispatch(contributionFundsDocumentStorageError());
        }
    );

}


const fetchCancelPeriodicalContributionsFetching = () => (
    {
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_CANCEL_FETCHING,
    }
);


const fetchCancelPeriodicalContributionsError = (error) => (
    {
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_CANCEL_ERROR,
        payload: error
    }
);

const fetchCancelPeriodicalContributionsSuccess = () => dispatch => {
    dispatch({
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_CANCEL_SUCCESS,
    });
}

const resetCancelPeriodicalContribution = ()=> (
    {
        type: actionTypes.BROKER_FETCH_PERIODICAL_CONTRIBUTIONS_CANCEL_RESET,
    }
);

const fetchCancelPeriodicalContribution = (history) => (dispatch, getState) =>{
    dispatch(fetchCancelPeriodicalContributionsFetching())
    const url =  apiURLBuilder.getURL('brokerInactivationRecurringTransfer');
    const immBrokerPeriodicalContribution = getState().brokerPeriodicalFundsContributions;
    const token = immBrokerPeriodicalContribution.get('token');
    const periodicalContributionSelected = immBrokerPeriodicalContribution.get('periodicalContributionSelected')
    const amount = periodicalContributionSelected.get('amount');
    const currencyCode = periodicalContributionSelected.get('currencyCode');
    const contractCode = periodicalContributionSelected.get('contractCode');
    const nextInstallmentDate = periodicalContributionSelected.get('nextInstallmentDate');
    const periodicity = periodicalContributionSelected.get('periodicity');
    const productId = periodicalContributionSelected.get('productId');
    const subscriptionDate = periodicalContributionSelected.get('subscriptionDate');
    const subscriptionDateId = periodicalContributionSelected.get('subscriptionDateId');
    const requestData = {
        query: {
            amount: amount,
            channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
            contractCode,
            currencyCode,
            dataToken: token,
            nextInstallmentDate,
            periodicity,
            productId,
            subscriptionDate,
            subscriptionDateId,
        },
        header: {
            version: 2,
        }
    }
    APIPost(dispatch, url, requestData).then(
        (response) => {
            dispatch(fetchCancelPeriodicalContributionsSuccess(response))
            dispatch(storeDocument(response));
        },
        (error) =>{
            dispatch(fetchCancelPeriodicalContributionsError(error));
            dispatch(errorActions.show('', true, history))
        },
    );
}

const signaturePatternSuccess = token => dispatch => {
    dispatch({
        type: actionTypes.BROKER_PERIODICAL_CONTRIBUTION_SIGNATURE_SUCCESS,
        payload: token
    });
}

const cancelPeriodicalContribution = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(fetchCancelPeriodicalContribution(history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};


module.exports = {
    fetchPeriodicalContributions,
    handleRowClick,
    handlePeriodicalContributionSelected,
    changePage,
    getPeriodicalContributions,
    cancelPeriodicalContribution,
    resetCancelPeriodicalContribution
};
